module.exports = __webpack_public_path__ + "img/stanley-pro.4c87f798.jpg";